import { render } from "./panelNewsMs.vue?vue&type=template&id=4dcc4a0e"
import script from "./panelNewsMs.vue?vue&type=script&lang=js"
export * from "./panelNewsMs.vue?vue&type=script&lang=js"

import "./panelNewsMs.vue?vue&type=style&index=0&id=4dcc4a0e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__